module.exports = __webpack_public_path__ + "img/winter_100x100.e91f26d4.png";